/**
 * Site-wide facts shared by the client, Pages Functions and build scripts.
 * Pure data: no React, DOM or Vite env vars here (see base/purity.test.ts).
 */

export const SITE_URL = "https://codecious.com";
export const SITE_NAME = "Codecious";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;

/** Cloudflare Turnstile public site key (bound to codecious.com). */
export const TURNSTILE_SITEKEY = "0x4AAAAAACC9vH5kwIc4-EUl";

export const ORG = {
  name: "Codecious",
  cnpj: "54.480.178/0001-06",
  address: {
    street: "Av. Paulista, 1106, Sala 01, Andar 16",
    city: "São Paulo, SP",
  },
  email: "contato@codecious.com",
  whatsapp: {
    display: "(77) 99865-4737",
    url: "https://wa.me/5577998654737",
  },
  social: {
    linkedin: "https://linkedin.com/company/codecious",
    instagram: "https://instagram.com/codeciousbr",
    facebook: "https://facebook.com/codeciousbr",
  },
} as const;
